import moment from "moment";

// Comparateur pour le tri des colonnes (sort comparator)
export const dateComparator = (valueA, valueB) => {
    const dateA = moment(valueA).utcOffset(0, true);
    const dateB = moment(valueB).utcOffset(0, true);

    if (!dateA.isValid()) return 1;
    if (!dateB.isValid()) return -1;
    if (dateA.isSame(dateB)) return 0;
    return dateA.isBefore(dateB) ? -1 : 1;
};

// Comparateur pour les filtres agDateColumnFilter (filterParams.comparator)
// Compare le jour uniquement (ignore l'heure) pour que "égal à" fonctionne
export const dateFilterComparator = (filterDate, cellValue) => {
    if (!cellValue) return -1;
    const cellDay = moment(cellValue).startOf('day');
    const filterDay = moment(filterDate).startOf('day');
    if (cellDay.isBefore(filterDay)) return -1;
    if (cellDay.isAfter(filterDay)) return 1;
    return 0;
};
